import { render, staticRenderFns } from "./RencanaAksiUpt.vue?vue&type=template&id=49e52469&"
import script from "./RencanaAksiUpt.vue?vue&type=script&lang=js&"
export * from "./RencanaAksiUpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports